import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ResponseObject } from 'src/app/models/response-object.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InventoryReportService {

  private url = environment.api;

  constructor(
    private http: HttpClient,
  ) { }

  /**
   * 
   * @param startDate 
   * @param endDate 
   * @param type 'pdf' or 'excel'
   * @returns file
   */
  getSalesReport(startDate: number, endDate: number, type: string) {
    return this.http.get(this.url + 'api/erp/accounting/report/v2/sales/' + startDate + '/' + endDate + '/' + type);
  }

  /**
   * 
   * @param startDate 
   * @param endDate 
   * @param type 
   * @returns 
   */
  getIntegratedSaleReport(startDate: number, endDate: number, type: string) {
    return this.http.get(this.url + 'api/erp/accounting/report/v2/integratedSale/' + startDate + '/' + endDate + '/' + type);
  }

  getIntegratedSaleOutReport(startDate: number, endDate: number, type: string) {
    return this.http.get(this.url + 'api/erp/accounting/report/v2/integratedSaleOut/' + startDate + '/' + endDate + '/' + type);
  }

  getInventoryBalancesReport(startDate: number, endDate: number, type: string, warehouseId = 0) {
    return this.http.get(this.url + 'api/erp/accounting/report/v2/inventoryBalances/' + startDate + '/' + endDate + '/' + type, {
      params: {
        warehouseId: warehouseId
      }
    });
  }

  getPriceListReport(startDate: number, endDate: number, type: string) {
    return this.http.get(this.url + 'api/erp/accounting/report/v2/priceList/' + startDate + '/' + endDate + '/' + type);
  }

  getAverageExistenceReport(date: number, typeInv: string, warehouse: number, type: string) {
    return this.http.get(this.url + "api/erp/inventory/reports/existence/average/" + type, {
      params: {
        date: date,
        type: typeInv,
        warehouse: warehouse
      }
    });
  }

  getInvoiceSalesReport(startDate: number, endDate: number, type: string) {
    return this.http.get(this.url + 'api/erp/accounting/report/v2/invoicesSale/' + startDate + '/' + endDate + '/' + type);
  }


  getExistenceInventoryReport(
    date: number,
    typeInv: string,
    warehouse: number | null,
    product: number | null,
    type: string
  ) {
    const params: any = {
      date: date,
      type: typeInv
    };

    if (warehouse != null && Number(warehouse) !== 0) {
      params.warehouse = warehouse;
    }

    if (product != null && Number(product) !== 0) {
      params.product = product;
    }

    return this.http.get(
      this.url + "api/erp/inventory/reports/existence/" + type,
      { params }
    );
  }


  getEntryReport(startDate: number, endDate: number, typeInv: string, warehouse: number, type: string) {
    return this.http.get(this.url + "api/erp/inventory/reports/ins/" + type, {
      params: {
        startDate: startDate,
        endDate: endDate,
        type: typeInv,
        warehouse: warehouse
      }
    });
  }

  getCardexInventoryReport(startDate: number, endDate: number, product: number, warehouse: number, type: string) {
    return this.http.get(this.url + "api/erp/inventory/reports/cardex/" + type, {
      params: {
        startDate: startDate,
        endDate: endDate,
        product: product,
        warehouse: warehouse
      }
    });
  }

  getSeasonalityReport(month: number, year: number, warehouse: number, type: string) {
    return this.http.get(this.url + "api/erp/inventory/reports/seasonality/" + type, {
      params: {
        month: month,
        year: year,
        warehouse: warehouse
      }
    });
  }

  getProfitMarginReport(startDate: number, endDate: number, product: number, warehouse: number, type: string) {
    if (product) {
      return this.http.get(this.url + "api/erp/inventory/reports/profitmargin/" + type, {
        params: {
          startDate: startDate,
          endDate: endDate,
          product: product,
          warehouse: warehouse
        }
      });
    } else {
      return this.http.get(this.url + "api/erp/inventory/reports/profitmargin/" + type, {
        params: {
          startDate: startDate,
          endDate: endDate,
          warehouse: warehouse
        }
      });
    }
  }

  getProfitMarginReportByDestination(startDate: number, endDate: number, product: number, destination: number, type: string) {
    if (product) {
      return this.http.get(this.url + "api/erp/inventory/reports/profitmargin-destination/" + type, {
        params: {
          startDate: startDate,
          endDate: endDate,
          product: product,
          destination: destination
        }
      });
    } else {
      return this.http.get(this.url + "api/erp/inventory/reports/profitmargin-destination/" + type, {
        params: {
          startDate: startDate,
          endDate: endDate,
          destination: destination
        }
      });
    }
  }

  getProfitMarginReportByMultiDestination(startDate: number, endDate: number, product: number, data: any, type: string) {
    if (product) {
      return this.http.post(this.url + "api/erp/inventory/reports/profitmargin-multi-destination/" + type, data, {
        params: {
          startDate: startDate,
          endDate: endDate,
          product: product
        }
      });
    } else {
      return this.http.post(this.url + "api/erp/inventory/reports/profitmargin-multi-destination/" + type, data, {
        params: {
          startDate: startDate,
          endDate: endDate
        }
      });
    }
  }

  getProfitMarginByClientReport(startDate: number, endDate: number, product: number, warehouse: number, client: number, type: string) {
    return this.http.get(this.url + "api/erp/inventory/reports/profitmargin/clients/products/" + type, {
      params: {
        startDate: startDate,
        endDate: endDate,
        client: client ? client : '',
        product: product ? product : '',
        warehouse: warehouse
      }
    });
  }

  getTransformReport(startDate: number, endDate: number, warehouse: number, type: string) {
    return this.http.get(this.url + "api/erp/inventory/reports/transfers/transformations/" + type, {
      params: {
        startDate: startDate,
        endDate: endDate,
        warehouse: warehouse
      }
    });
  }

  getAuditInventoryPDF(startDate, endDate, warehouseId) {
    return this.http.post(this.url + `api/erp/inventory/realizationPdf/${warehouseId}/${startDate}/${endDate}`, null);
  }

  getAssociatedReport(fileType: string) {
    return this.http.get(this.url + `api/erp/inventory/reports/associated/${fileType}`);
  }

  //project/data/{fileType}
  getProjectDataReport(fileType: string, startDate: number, endDate: number) {
    return this.http.get(this.url + `api/erp/inventory/reports/project/data/${fileType}`, {
      params: {
        startDate: startDate,
        endDate: endDate
      }
    });
  }

  getNotAssociatedProducts(fileType: string) {
    return this.http.get(this.url + `api/erp/inventory/reports/notAssociatedProducts/${fileType}`);
  }

  getMoveInventory(fileType: string, request) {
    return this.http.post(this.url + `api/erp/inventory/reports/move-inventory/${fileType}`, request);
  }

  getFamiliesReport(fileType: string) {
    return this.http.post(this.url + `api/erp/inventory/reports/families-product/${fileType}`, null);
  }

  getGeneralSeasonality(fileType: string, request) {
    return this.http.post(this.url + `api/erp/inventory/reports/general-seasonality/${fileType}`, request);
  }

  getGeneralTable(startDate: string, endDate: string, type: string) {
    return this.http.get(this.url + `api/erp/accounting/report/v2/general-table/${type}`, {
      params: {
        startDate: startDate,
        endDate: endDate,
      }
    });
  }

  getAdministrativeInvoices(startDate: string, endDate: string, type: string): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.url}/administrative-invoices/${type}?startDate=${startDate}&endDate=${endDate}`
    );
  }

  getAdministrativeInvoicesV2(startDate: string, endDate: string, type: string): Observable<ResponseObject> {
    return this.http.get<ResponseObject>(
      `${this.url}/administrative-invoicesV2/${type}?startDate=${startDate}&endDate=${endDate}`
    );
  }
}
